import React from 'react';

const ServicesOneABoutPediatricsNeonatology = () => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="section-title section-title-m-0 pos-rel mb-50 text-end">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-right" src="img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text section-text-small pos-rel">
                           <h5>health care facility</h5>
                           <h1>Would you rather stay at home than go into a health care facility?</h1>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="facalty-text mb-50">
                        <p>
                           Neonatology is a subspecialty of pediatrics that consists of the medical care of newborn infants, especially the ill or premature newborn. It is a hospital-based specialty, and is usually practised in neonatal intensive care units.
                           <br />
                           We encompass all advanced technologies and the most advanced facilities with a prime focus on the safe and proven treatment of disorders aiming at improving the quality of life of the patient.
                        </p>
                     </div>
                  </div>
               </div>
               {/* <div className="row">
                  <HomeSIngleService icon="1" title="Body Surgery" border_className="service-box-border" />
                  <HomeSIngleService icon="2" title="Dental Care" border_className="service-box-border" />
                  <HomeSIngleService icon="3" title="service-content" border_className="service-box-border" />
                  <HomeSIngleService icon="4" title="Blood Cancer" border_className="service-box-border" />
                  <HomeSIngleService icon="5" title="Neurology Sargery" border_className="service-box-border" />
                  <HomeSIngleService icon="6" title="Allergic Issue" border_className="service-box-border" />
               </div> */}
            </div>
         </section>
      </>
   );
};

export default ServicesOneABoutPediatricsNeonatology;